import React from "react";
import TravelDetailsForm from "./TravelDetailsForm";
import TravelPreferenceForm from "./TravelPreferenceForm";
import TravelRequirementForm from "./TravelRequirementForm";
import Typography from "./Typography";
import { Colors } from "../../config";
import FormSectionHeader from "./FormSectionHeader";

const NonMultiCityForm = ({
  flightTypes,
  payType,
  travelType,
  data,
  onFlightTypeSelect,
  onTravelTypeSelect,
  onPayTypeSelect,
  onAirportSelect,
  onTimeRangeSelect,
  onCheckAirlines,
  onDateSelection,
  onTravelReqChange,
  onCompanySelected,
  errors,
  // minStartDate,
  // maxEndDate,
  // carTypes,
  // hotelTypes,
  selectedLeave,
  companies,
  perDiemData,
  settingsData,
  companyList,
  costCenterList,
  projectList,
  onPrivilegeChange,
  privilegeCard,
  activeTripType,
}) => {
  return (
    <>
      <FormSectionHeader label="Travel Details" />
      <TravelDetailsForm
        flightTypes={flightTypes}
        data={data}
        onFlightTypeSelect={onFlightTypeSelect}
        onAirportSelect={onAirportSelect}
        onTimeRangeSelect={onTimeRangeSelect}
        onCheckAirlines={onCheckAirlines}
        onDateSelection={onDateSelection}
        errors={errors}
        selectedLeave={selectedLeave}
        onPrivilegeChange={onPrivilegeChange}
        privilegeCard={privilegeCard}
        activeTripType={activeTripType}
        // minStartDate={minStartDate}
        // maxEndDate={maxEndDate}
      />
      <FormSectionHeader label="Travel Entitlements" />
      <TravelPreferenceForm
        data={data}
        payType={payType}
        companies={companies}
        travelType={travelType}
        onTravelTypeSelect={onTravelTypeSelect}
        onPayTypeSelect={onPayTypeSelect}
        errors={errors}
        onCompanySelected={onCompanySelected}
        perDiemData={perDiemData}
        companyList={companyList}
        costCenterList={costCenterList}
        projectList={projectList}
      />
      <FormSectionHeader label="Select required travel services" />
      <TravelRequirementForm
        data={data?.businessRequirement}
        onTravelReqChange={onTravelReqChange}
        errors={errors?.businessRequirement}
      />
    </>
  );
};

export default NonMultiCityForm;
